<template>
  <div class="red-test">
    <b-container style="max-width: 810px">
      <b-row>
        <b-col class="calendar-action-buttons text-right pr-0">
          <b-button class="non-printable mr-1" @click="printCalendar('printable-calendar')"  v-if="config.enablePrint">Print</b-button>
          <b-button class="non-printable" @click="done()">Done</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="mt-4 menu-container" v-if="item" id="printable-calendar">
      <div class="gradient-background" >
        <h1 class="font-weight-bolder heading">{{title}}</h1>
        <hr class="red-highlight" />
        <h3 class="text-uppercase font-weight-bolder  menu-item-title pt-4" v-if="config.showDate">{{ menuDate }}</h3>
        <div class="menu-item-title" v-if="item.title && config.showTitle">{{ item.title }}</div>
        <div class="menu-item-description mb-4" v-if="item.description && config.showTitle">{{ item.description }}</div>
        <hr class="red-highlight" v-if="config.showDayName || (item.description && config.showDescription) || (item.title && config.showTitle)" />
        <!-- {{ item.menuDate }} -->
        <div>
          <div class="mb-2 menu-item-description" :class="'row'+((index % 2) ? 2 : 1)" v-for="(val, index) in item.choices" :key="index">
            <div class="menu-item-title">{{ val.title }}</div>
            <div class="menu-item-description mt-2" v-if="config.showDescription">{{val.description}}</div>
            <div class="menu-item-description" v-if="val.title && config.showPrice">Price: ${{val.price[config.priceLevel]}}</div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Moment from "moment"

export default {
  name: 'DailyMenu',
  components: {
  },
  props: {
    title: { type: String, default: "Today" },
    item: {
      type: Object,
      default: () => {}
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
     
    }
  },
  mounted() {
    console.log("mounted ", this.item)
  },
  computed: {
    menuDate() {
      return Moment(this.item.menuDate).format('dddd, MMMM Do')
    }
  },
  methods: {
    done() {
      this.$emit( 'done' );
    },
    printCalendar() {
      window.print();
    }
  }
}
</script>
<style lang="scss">
  @font-face{
    font-family: acmeRegular;
    src: url('./acme-regular.ttf');
  }
  @font-face{
    font-family: aladinRegular;
    src: url('./aladin-regular.ttf');
  }
  @font-face{
    font-family: arapeyRegular;
    src: url('./arapey-regular.ttf');
  }
  .menu-container{
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
      background: url('./texture.png') no-repeat;
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-size: cover;
    }
    * {
      color: #000;
    }
    position: relative;
    overflow: hidden;
    background: rgba(253, 219, 158, .2);
    color: #fff;
    // padding-top: 20px;
    // padding-bottom: 20px;
    // margin-bottom:6em;
    width: 8.5in;
    height: 11in;;
    border: 1px dashed #f1a00f;
    -webkit-box-shadow: 5px 5px 15px 5px #000000; 
    box-shadow: 5px 5px 15px 5px #000000;
    .menu-item-title{
      padding: 10px;
      font-size: 30px;
      font-weight: 900 !important;
      letter-spacing: 5px;
      padding-bottom: 0;
      font-family: aladinRegular;
    }
    .menu-item-description {
      display: block;
      white-space: pre-wrap;
      font-size: 18px;
      color: #000;
      line-height: 1.5;
      font-weight: 600;
      margin-top: 0 !important;
      font-family: arapeyRegular;
    }
    .heading{
      color:#000;
      margin-bottom: 12px;
      font-size: 52px;
      // text-shadow: 2px 2px 2px red;
      font-family:acmeRegular;
    }
    .gradient-background{
      z-index: 100;
      position: relative;
    }
    hr {
      border: 0;
      height: 1px;
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
      margin-top: 0;
      clear: both;
      float: left;
      width: 100%;
      &.red-highlight {
        background: linear-gradient(to right, rgba(194, 58, 43, 0), rgba(194, 58, 43, 0.75), rgba(194, 58, 43, 0));
      }
    }
  }

  @media print {
    
    body {
      -webkit-print-color-adjust: exact !important;
    }
    body{
      background-color: red;
    }
    .menu-container{
      width: 100% !important;
      height: 1378px !important;
    }
    @page {
      margin:0px !important;
      padding: 0px;
      
    }

    .non-printable, #nav {
      display: none;
    }
  }

  /* style sheet for "letter" printing */
  @page {
    size: A4;
    margin: 0;
  }
</style>